export function assetUrl(p: string): string {
    const base = process.env.NEXT_PUBLIC_BASE_PATH || "";
    if (!p) return base || "/";
    // passthrough absolute URLs and data URIs
    if (/^(https?:\/\/|data:)/i.test(p)) return p;
    const norm = p.startsWith("/") ? p : `/${p}`;
    // avoid double-prefix when already includes base
    if (base && norm.startsWith(base + "/")) return norm;
    return `${base}${norm}`;
}
